import { lazyWithRetry } from 'src/react-app/utilits/lazy-with-retry'

export const ExcelFileAsync = lazyWithRetry(() => import('./excel-file'))
